/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dashboard_Action_Add_JobInputs */

const en_dashboard_action_add_job = /** @type {(inputs: Dashboard_Action_Add_JobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add Job`)
};

const de_dashboard_action_add_job = /** @type {(inputs: Dashboard_Action_Add_JobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stelle hinzufügen`)
};

const fr_dashboard_action_add_job = /** @type {(inputs: Dashboard_Action_Add_JobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ajouter un emploi`)
};

const es_dashboard_action_add_job = /** @type {(inputs: Dashboard_Action_Add_JobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Añadir empleo`)
};

const it_dashboard_action_add_job = /** @type {(inputs: Dashboard_Action_Add_JobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aggiungi Lavoro`)
};

const nl_dashboard_action_add_job = /** @type {(inputs: Dashboard_Action_Add_JobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voeg Baan Toe`)
};

const pl_dashboard_action_add_job = /** @type {(inputs: Dashboard_Action_Add_JobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dodaj ogłoszenie`)
};

const fi_dashboard_action_add_job = /** @type {(inputs: Dashboard_Action_Add_JobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lisää työpaikka`)
};

const da_dashboard_action_add_job = /** @type {(inputs: Dashboard_Action_Add_JobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tilføj job`)
};

const sv_dashboard_action_add_job = /** @type {(inputs: Dashboard_Action_Add_JobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lägg till Jobb`)
};

/**
* | output |
* | --- |
* | "Add Job" |
*
* @param {Dashboard_Action_Add_JobInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const dashboard_action_add_job = /** @type {((inputs?: Dashboard_Action_Add_JobInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dashboard_Action_Add_JobInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_dashboard_action_add_job(inputs)
	if (locale === "fr") return fr_dashboard_action_add_job(inputs)
	if (locale === "es") return es_dashboard_action_add_job(inputs)
	if (locale === "it") return it_dashboard_action_add_job(inputs)
	if (locale === "nl") return nl_dashboard_action_add_job(inputs)
	if (locale === "pl") return pl_dashboard_action_add_job(inputs)
	if (locale === "fi") return fi_dashboard_action_add_job(inputs)
	if (locale === "da") return da_dashboard_action_add_job(inputs)
	if (locale === "sv") return sv_dashboard_action_add_job(inputs)
	return en_dashboard_action_add_job(inputs)
});